export const SET_HAS_TALENTS_DATA = "SET_HAS_TALENTS_DATA";

export const SetHasTalentsData = (value) => {
  return {
    type: SET_HAS_TALENTS_DATA,
    payload: {
      value: value,
    },
  };
};
